import { render, staticRenderFns } from "./RenderPlaceholder.vue?vue&type=template&id=6829b0ec&scoped=true&"
import script from "./RenderPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./RenderPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./render_place_holder.scss?vue&type=style&index=0&id=6829b0ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6829b0ec",
  null
  
)

export default component.exports